import React from "react";
import "./VehicleDetailsPanel.css";

const VehicleDetailsPanel = ({ vehicle, onClose }) => {
  const isMoving = vehicle.speed > 0;

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  return (
    <div className="vehicle-details-panel">
      <div className="panel-header">
        <h3>Vehicle Details</h3>
        <button className="close-btn" onClick={onClose} aria-label="Close">
          ✕
        </button>
      </div>

      <div className="panel-content">
        {/* Vehicle Number */}
        <div className="detail-section">
          <div className="detail-header">
            <h4>Vehicle Number</h4>
          </div>
          <div className="vehicle-number">{vehicle.vehicleregnumber}</div>
        </div>

        {/* Status */}
        <div className="detail-section">
          <div className="detail-row">
            <label>Status</label>
            <span className={`status-badge ${isMoving ? "moving" : "stopped"}`}>
              {isMoving ? "🟢 Moving" : "🔴 Stopped"}
            </span>
          </div>
          <div className="detail-row">
            <label>Speed</label>
            <span className="speed-value">{vehicle.speed} km/h</span>
          </div>
        </div>

        {/* Location */}
        <div className="detail-section">
          <div className="detail-header">
            <h4>Location</h4>
          </div>
          <div className="detail-row">
            <label>Latitude</label>
            <span>{vehicle.latitude?.toFixed(6) || "N/A"}</span>
          </div>
          <div className="detail-row">
            <label>Longitude</label>
            <span>{vehicle.longitude?.toFixed(6) || "N/A"}</span>
          </div>
          {vehicle.address && (
            <div className="detail-row full-width">
              <label>Address</label>
              <span className="address-text">{vehicle.address}</span>
            </div>
          )}
        </div>

        {/* Additional Info */}
        <div className="detail-section">
          <div className="detail-header">
            <h4>Additional Information</h4>
          </div>
          {vehicle.lastUpdated && (
            <div className="detail-row">
              <label>Last Updated</label>
              <span className="small-text">
                {formatDate(vehicle.lastUpdated)}
              </span>
            </div>
          )}
          {vehicle.driver && (
            <div className="detail-row">
              <label>Driver</label>
              <span>{vehicle.driver}</span>
            </div>
          )}
          {vehicle.fuel !== undefined && (
            <div className="detail-row">
              <label>Fuel Level</label>
              <span>{vehicle.fuel}%</span>
            </div>
          )}
          {vehicle.odometer !== undefined && (
            <div className="detail-row">
              <label>Odometer</label>
              <span>{vehicle.odometer} km</span>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="detail-actions">
          <button className="action-btn primary">View History</button>
          <button className="action-btn secondary">Get Directions</button>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetailsPanel;
